import React, { useState } from 'react';

const Pagination = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [jumpPage, setJumpPage] = useState(currentPage);

  const handleJump = () => {
    const page = Math.min(Math.max(1, jumpPage), totalPages);
    onPageChange(page);
  };

  return (
    <div className="flex pb-12 flex-col sm:flex-row sm:items-center sm:justify-between mt-6 space-y-4 sm:space-y-0">
      {/* Items Per Page Selector */}
      <div className="flex items-center space-x-2">
        <label htmlFor="itemsPerPage" className="text-sm text-gray-700">
          Items per page:
        </label>
        <select
          id="itemsPerPage"
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
          className="border rounded px-2 py-1 text-sm"
        >
          {[9, 15, 30, 60, 120].map((num) => (
            <option key={num} value={num}>
              {num}
            </option>
          ))}
        </select>
      </div>

      {/* Pagination Controls */}
      <div className="flex items-center space-x-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1 border rounded text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50"
        >
          Prev
        </button>

        {[...Array(totalPages).keys()].map((i) => {
          const page = i + 1;
          return (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`px-3 py-1 border rounded text-sm ${
                currentPage === page
                  ? 'bg-indigo-600 text-white border-indigo-600'
                  : 'text-gray-700 hover:bg-gray-100 border-gray-300'
              }`}
            >
              {page}
            </button>
          );
        })}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-1 border rounded text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50"
        >
          Next
        </button>
      </div>

      {/* Quick Jump */}
      <div className="flex items-center space-x-2">
        <label htmlFor="jumpTo" className="text-sm text-gray-700">
          Jump to:
        </label>
        <input
          id="jumpTo"
          type="number"
          min={1}
          max={totalPages}
          value={jumpPage}
          onChange={(e) => setJumpPage(Number(e.target.value))}
          className="w-16 border rounded px-2 py-1 text-sm"
        />
        <button
          onClick={handleJump}
          className="px-3 py-1 bg-indigo-600 text-white rounded text-sm hover:bg-indigo-700"
        >
          Go
        </button>
      </div>
    </div>
  );
};

export default Pagination;
